<div class="vtr-widget-warranty"
	[ngClass]="{'in-warranty': item.info.status == 0, 'expired': item.info.status == 1, 'not-found': item.info.status == 2}">
	<div class="container-fluid">
		<div class="row">
			<div class="col"
				*ngIf="item.info.status >= 0">
				<div class="title pb-20" *ngIf="item.info.status !== 2">{{status.title[item.info.status] | translate}}</div>
				<div class="title title-detail pb-20" *ngIf="item.info.status === 2">{{'support.warranty.warrantyDashboardDetails' | translate}}</div>
				<div class="content"
					*ngIf="item.info.status == 1 || item.info.status == 0">
					<div class="sub-title">
						{{ year }}{{'support.warranty.yearDepotWarranty' | translate}}
					</div>
					<div class="sub-description pb-20">
						<span [innerHTML]="'support.warranty.subDescription1' | translate"></span>
						<span *ngIf="!isConnected && item.cache"> {{'support.warranty.offlineTips1' | translate}}</span>
						<span *ngIf="!isConnected && !item.cache"> {{'support.warranty.offlineTips2' | translate}}</span>
					</div>
					<div class="sub-title">{{'support.warranty.warrantyDetails' | translate}}</div>
					<div class="sub-description pb-20">
						<div class="pb-2">
							{{'support.warranty.startDate' | translate}}<b>{{item.info.startDate | formatLocaleDate}}</b></div>
						<div class="pb-2">
							{{'support.warranty.endDate' | translate}}<b>{{item.info.endDate | formatLocaleDate}}</b></div>
						<div class="pb-2">
							{{'support.warranty.status' | translate}}<b>{{status.detail[item.info.status] | translate}}</b>
						</div>
					</div>
				</div>
				<div class="content"
					*ngIf="item.info.status == 2">
					<div class="sub-description pb-20">
						<span [innerHTML]="'support.warranty.subDescription2' | translate"></span>
						<span *ngIf="!isConnected && item.cache"> {{'support.warranty.offlineTips1' | translate}}</span>
						<span *ngIf="!isConnected && !item.cache"> {{'support.warranty.offlineTips2' | translate}}</span>
					</div>
				</div>
				<div class="button-box">
					<vtr-ui-button linkId="support-view-warranty-options"
						[tabIndex]="100"
						buttonColor="gray"
						[isFullWidth]="true"
						[inRedBackground]="item.info.status==1"
						[label]="'support.warranty.viewWarrantyOptions' | translate"
						[href]="item.info.url"></vtr-ui-button>
				</div>
			</div>
		</div>
	</div>
</div>
